<div class="wrapper">
    <app-public-header></app-public-header>
    <div class="public-panel">
        <router-outlet></router-outlet>
        <app-footer [open]="true"></app-footer>
    </div>
</div>
